var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoPublicacionesMantenedor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3C17.1716 3 16.5 3.67157 16.5 4.5V5C16.5 6.65685 15.1569 8 13.5 8L12 8V15H24V8H22.5C20.8431 8 19.5 6.65686 19.5 5V4.5C19.5 3.67157 18.8284 3 18 3ZM13.5 4.5C13.5 2.01472 15.5147 0 18 0C20.4853 0 22.5 2.01472 22.5 4.5V5L24 5C25.6569 5 27 6.34315 27 8V10.5H33C34.6569 10.5 36 11.8431 36 13.5V20.3788L33 23.3788V13.5H27V15C27 16.6569 25.6569 18 24 18H12C10.3431 18 9 16.6569 9 15V13.5H3V45H33V36.6214L36 33.6214V45C36 46.6569 34.6569 48 33 48H3C1.34315 48 0 46.6569 0 45V13.5C0 11.8431 1.34315 10.5 3 10.5H9V8C9 6.34314 10.3431 5 12 5H13.5V4.5Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8792 16.4998C41.0508 15.3282 42.9503 15.3282 44.1219 16.4998L46.5006 18.8785C47.6721 20.05 47.6721 21.9495 46.5006 23.1211L31.355 38.2666C30.9705 38.6511 30.4888 38.9239 29.9613 39.0558L25.577 40.1518C23.9292 40.5638 22.4366 39.0711 22.8485 37.4233L23.9446 33.039C24.0765 32.5115 24.3492 32.0298 24.7337 31.6453L39.8792 16.4998ZM42.0006 18.6211L26.855 33.7666L26.0621 36.9382L29.2337 36.1453L44.3792 20.9998L42.0006 18.6211Z",
    fill: "#FD6C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoPublicacionesMantenedor);
export default __webpack_public_path__ + "static/media/icono-publicaciones-mantenedor.b0afadf85fdae18f1221d5cca1b9cebd.svg";
export { ForwardRef as ReactComponent };